// ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import FirebaseAuthHelper from "../../features/authentication/helpers/firebase-auth-helper/firebase-auth-helper";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const user = FirebaseAuthHelper.getCurrentUser();
  const role = useSelector((s) => s.userStore?.userInfo?.role);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (role === "b2c") {
    const allowed = ["/connect-contacts", "/manage-contacts", "/manage-groups"];
    const isAllowed = allowed.some((p) => location.pathname.startsWith(p));
    if (!isAllowed) {
      return <Navigate to="/manage-groups" />;
    }
  }

  return children;
};

export default ProtectedRoute;
